<template>
  <div id="single-service-wrapper">
    <div
      id="single-service-content"
      class="SingleService single-service-scroller"
    >
      <section class="paddingPrivate" />
      <section class="WorkFilter__container">
        <div
          v-for="(filteredProject, index) in content.projects"
          :key="`filteredProject${index}`"
          class="WorkFilter__item"
        >
          <InertiaLink
            class="WorkFilter__item--link"
            :href="`/work/${filteredProject.slug}/${content.password}`"
          >
            <div class="WorkFilter__item--image-container">
              <img
                v-if="filteredProject.thumbnail_4_5"
                :data-src="getImageKitURL(filteredProject.thumbnail_4_5, 3, filteredProject.image_type,false,index,'images')"
                :src="getImageKitURL(filteredProject.thumbnail_4_5, 3, filteredProject.image_type, true,index,'images')"
                :alt="filteredProject.title"
                class="WorkFilter__item--image"
              >
              <img
                v-else
                :src="`${$store.state.baseimageUrl}default-thumb-4-5.png`"
                class="WorkFilter__item--image"
                alt="default image"
              >
            </div>

            <h5 class="small-subtitle grey WorkFilter__text">
              {{ filteredProject.client_subtitle }}
            </h5>
            <h3 class="small-title black WorkFilter__text">
              <span
                v-if="filteredProject.published == 0 && $page.props.auth.user"
                class="orange"
              >*</span>{{ filteredProject.title }}
            </h3>
            <h4 class="small-subtitle orange WorkFilter__text">
              {{ filteredProject.subtitle }}
            </h4>
          </InertiaLink>
        </div>
      </section>


      <span id="single-service-content-footer" />
      <TheFooter />
    </div>
  </div>
</template>

<script>
/* Vendor */
import { nextTick } from 'vue';
import { InertiaLink } from "@inertiajs/inertia-vue3";

/* Helpers */
import { mainLayout } from "@/helpers/vue-layouts";
import seo from "@/helpers/seo";

/* Mixins */
import page from "@/mixins/page";
import imageKit from "@/mixins/image-kit";
import scrollGlobal from "@/mixins/scroll-global";
import loader from "@/mixins/loader";

export default {
  components: {
    InertiaLink
  },

  mixins: [page, scrollGlobal, loader, imageKit],

  layout: mainLayout,

  props: {
    position: {
      type: Number,
      default: 1000
    },
    content: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      headerColorinit: null,
      bgScrollAnimation:null,
    };
  },

  computed: {
    customColor() {
      if (this.content.bg_top_bar) {
        return this.content.bg_top_bar;
      } else {
        return "transparent";
      }
    },
    visibleFeaturedProjects() {
      return this.content.featured_projects.filter(
        (project) => project.published == 1 || this.$page.props.auth.user
      );
    }
  },

  created() {
    seo.seoContent(this.content);
  },

  mounted() {
    this.$nextTick(() => {
      console.log('init load images in page' );
      this.imagesToPreload = document.querySelectorAll("img");
      console.log('single service imgs',this.imagesToPreload  );
      this.getBackgroundImagesUrl();
      this.loadImages();

      if (this.content.vimeo_id) {
        this.cursorAnimations();
      }
    });
  },

  beforeUnmount() {
    this.bgScrollAnimation.scrollTrigger.kill();
    this.$gsap.to('.hideInAvatar', {opacity:1, duration:0.4});
  },

  methods: {
    init() {
      console.log('init');


      if (this.$store.state.isMobile) {
        if (this.content.white_logo_mb) {
          this.toggleMenuColor("white", 0, 0);
        } else {
          this.toggleMenuColor("black", 0, 0);
        }
      } else {
        if (this.content.white_logo) {
          this.toggleMenuColor("white", 0, 0);
        } else {
          this.toggleMenuColor("black", 0, 0);
        }
      }

      if (this.$store.state.isMobile && !this.content.transparent_header) {
        this.$gsap.to(".showBgHeader", { height: "100%", duration: 0 });
      }

      setTimeout(() => {
        this.setScroller('#single-service-wrapper', '#single-service-content' );

        // HEADER ANIMATIONS
        this.bgScrollAnimation = this.$gsap.to('.showBgHeader', {
          scrollTrigger: {
            trigger: '#single-service-content',
            markers: false,
            onEnter: this.updateHeaderState,
            onEnterBack: this.updateHeaderStateBack,
            start: '50px top',
            end: 'top bottom',
            toggleActions: 'play none reverse none',
          },
          height: '100%',
          duration: 0.2,
          ease: 'Power2.out',
        });

      }, 500);
      // this.$gsap.to('.hideInAvatar', {opacity:0, duration:0.4});
    },

    updateHeaderState() {
      if (this.$store.state.isMobile) {
        if (this.content.logo_white_mb_on_scroll) {
          this.toggleMenuColor("white", 0.2, 0);
        } else {
          this.toggleMenuColor("black", 0.2, 0);
        }
      } else {
        if (this.content.logo_white_on_scroll) {
          this.toggleMenuColor("white", 0.2, 0);
          console.log('updateHeaderState');
        } else {
          this.toggleMenuColor("black", 0.2, 0);
        }
      }
    },

    updateHeaderStateBack() {
      if (this.$store.state.isMobile) {
        if (this.content.menu_white_mobile) {
          this.toggleMenuColor("white", 0.2, 0);
        } else {
          this.toggleMenuColor("black", 0.2, 0);
        }
      } else {
        if (this.content.menu_white) {
          this.toggleMenuColor("white", 0.2, 0.4);
        } else {
          this.toggleMenuColor("black", 0.2, 0.4);
        }
      }
    },

    showModalVideo() {
      console.log('showModalVideo');
      this.$store.state.video_id = this.content.vimeo_id;

      if(this.content.vimeo_id){
        if(this.showVideoModal){
          setTimeout(() => {
            // this.showVideoModal = false;
            this.$store.commit("TOGGLE_IS_MODAL_VIDEO", false);
          }, 800);
        }else {
          this.$store.commit("TOGGLE_IS_MODAL_VIDEO", true);
        }

        window.history.pushState({id:1}, null, null);
      }


    },


    updateHeaderState(){
      this.toggleMenuColor('black', 0.2, 0);
      // this.$gsap.to('.hideInAvatar', {opacity:1, duration:0.4});
    },

    updateHeaderStateBack(){

      if (this.content.white_logo) {
        this.toggleMenuColor("white", 0.2, 0.4);
      } else {
        this.toggleMenuColor("black", 0.2, 0.4);
      }
      // this.$gsap.to('.hideInAvatar', {opacity:0, duration:0.4});
    },

    customCategory(categories) {
      let returnCats = [];
      for (let i = 0; i < categories.length; i++) {
        const cat = categories[i];
        switch (cat) {
          case "awards":
            returnCats.push("Awards");
            break;
          case "news":
            returnCats.push("News");
            break;
          case "project-feature":
            returnCats.push("Project Feature");
            break;
          case "talk":
            returnCats.push("Talk");
            break;
          case "interview":
            returnCats.push("Interview");
            break;
          default:
            returnCats.push(cat);
        }
      }

      return returnCats;
    },

    cursorAnimations() {
      //cursor animation
      this.$gsap.set(".cursorPlay", { xPercent: -50, yPercent: -50 });

      const play = document.querySelector(".cursorPlay");
      const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
      const mouse = { x: pos.x, y: pos.y };
      const speed = 0.3;

      const fpms = 60 / 1000;

      const xSet = this.$gsap.quickSetter(play, "x", "px");
      const ySet = this.$gsap.quickSetter(play, "y", "px");

      window.addEventListener("mousemove", (e) => {
        mouse.x = e.x;
        mouse.y = e.y;
      });

      this.$gsap.ticker.add((time, deltaTime) => {
        const delta = deltaTime * fpms;
        const dt = 1.0 - Math.pow(1.0 - speed, delta);

        pos.x += (mouse.x - pos.x) * dt;
        pos.y += (mouse.y - pos.y) * dt;
        xSet(pos.x);
        ySet(pos.y);
      });
    },

    mouseEnter(){
      if (this.content.vimeo_id) {
        this.$gsap.to('.cursorPlay', {opacity:1, duration: 0.2});

        this.$gsap.to('.cursorPlay svg', {fill:'white', duration: 0});
      }

    },
    mouseLeave(){
      if (this.content.vimeo_id) {
        this.$gsap.to('.cursorPlay', {opacity:0, duration: 0.2});
      }
    },
  }
}
</script>

<style lang="scss">
.paddingPrivate {
  @include paddingPageTop;
}
</style>
